/// Időben kiterjedt események rögzítésében segít
export class GoogleAnalyticsTimingHelper {
    private _timingStartDate: Date;
    private _timingFinishDate: Date;
    private _eventCategory: string;
    private _eventAction: string;
    private _eventLabel: string;

    constructor() {
        this._timingStartDate = null;
        this._timingFinishDate = null;
        this._eventCategory = null;
        this._eventAction = null;
        this._eventLabel = null;
    }

    /// Az esemény időmérésének a kezdete
    StartTiming(EventCategory: string, EventAction: string, EventLabel: string) {
        this._timingStartDate = new Date();
        this._timingFinishDate = null;
        this._eventCategory = EventCategory;
        this._eventAction = EventAction;
        this._eventLabel = EventLabel;
    }

    /// Az esemény időmérésének a vége (be is küldi az analyticsbe)
    FinishTiming() {
        if (this._timingStartDate != null) {
            this._timingFinishDate = new Date();

            SendEventToAnalytics(
                this._eventCategory,
                this._eventAction,
                this._eventLabel,
                this.GetElapsedTimeInSeconds()
            );
        } else {
            console.log("Timing does not even started");
        }
    }

    IsTimingActive() {
        if (this._timingStartDate != null
            && this._timingFinishDate == null) {
            return true;
        } else {
            return false;
        }
    }

    /// Vissza adja a StartTiming és FinishTiming között eltelt időt
    /// Ha az időmérés nem fejeződött be akkor StartTiming óta eltelt időt adja meg
    /// Ha nem kezdődött el az időmérés (-1) -el tér vissza.
    GetElapsedTimeInSeconds() {
        if (this._timingStartDate != null) {
            if (this._timingFinishDate != null) {
                return Math.floor((this._timingFinishDate.getTime() - this._timingStartDate.getTime()) / 1000);
            } else {
                return Math.floor((new Date().getTime() - this._timingStartDate.getTime()) / 1000);
            }
        } else {
            console.log("Timing does not even started");
        }
    }
}

// esemény küldése analyticsba
export function SendEventToAnalytics(EventCategory: string, EventAction: string, EventLabel: string, EventValue: number = 0) {

    if (typeof (ga) !== "undefined") {
        if (ga.hasOwnProperty('getAll')) {

            var trackers = ga.getAll();
            if (trackers.length > 0) {

                var tracker = trackers[0];
                // console.log("C: " + EventCategory + "  A: " + EventAction + "  L: " + EventLabel + "  V: " + EventValue);
                tracker.send('event', EventCategory, EventAction, EventLabel, EventValue, {
                    hitCallback: function () {
                        // sikeres küldés ellenőrzése
                    },
                    hitCallbackFail: function () {
                        console.log("Unable to send analytics data");
                    }
                });
            }
        }
    }
}

export function Analytics_Init(s: MVCxClientPageControl, e: ASPxClientEventArgs, ProcessActionViewName: string, TimerForMainTable: GoogleAnalyticsTimingHelper, TimerForProcessActionViews: GoogleAnalyticsTimingHelper, Category: string) {
    try {
        var TabName = s.GetActiveTab().GetText();
        TimerForMainTable.StartTiming(Category, TabName + ' fül', 'Táblázat nézegetésére szánt idő (másodpercben)');

        if (TabName === 'Cselekmények') {
            TimerForProcessActionViews.StartTiming(Category, TabName + ' fül (' + ProcessActionViewName + ')', 'Táblázat nézegetésére szánt idő (másodpercben)');
        }

        // oldal bezárás vagy elnavigálás eseménye
        window.addEventListener('beforeunload', function (event) {
            TimerForMainTable.FinishTiming();
            if (TimerForProcessActionViews.IsTimingActive()) {
                TimerForProcessActionViews.FinishTiming();
            }
        });

    } catch (err) {
        console.log("analytics hiba: " + err);
    }
}

export function Analytics_ActiveTabChanged(s: MVCxClientPageControl, e: ASPxClientEventArgs, ProcessActionViewName: string, TimerForMainTable: GoogleAnalyticsTimingHelper, TimerForProcessActionViews: GoogleAnalyticsTimingHelper, Category: string) {
    try {
        var TabName = s.GetActiveTab().GetText();
        TimerForMainTable.FinishTiming();
        TimerForMainTable.StartTiming(Category, TabName + ' fül', 'Táblázat nézegetésére szánt idő (másodpercben)');

        if (TabName === 'Cselekmények') {
            TimerForProcessActionViews.StartTiming(Category, TabName + ' fül (' + ProcessActionViewName + ')', 'Táblázat nézegetésére szánt idő (másodpercben)');
        } else {
            if (TimerForProcessActionViews.IsTimingActive()) {
                TimerForProcessActionViews.FinishTiming();
            }
        }

    } catch (err) {
        console.log("analytics hiba: " + err);
    }
}
